import React from 'react';
import WmsMobileLayout from "../../wmsMobileLayout";
import {FormattedMessage} from "react-intl";
import PageTitle from "../../../../components/WMS/Mobile/PageTitle";
import CreatePickingMissionForm from "../components/CreatePickingMissionForm";
import {Grid} from "@mui/material";

function CreatePickingMissionMobileContainer() {
    return (
        <WmsMobileLayout>
            <WmsMobileLayout.LeftHeader></WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader></WmsMobileLayout.RightHeader>
            <WmsMobileLayout.Content>
                <Grid
                    container
                    direction={'column'}
                    gap={'8px'}
                >
                    <Grid container gap={"48px"}>
                        <PageTitle
                            title={<FormattedMessage id={"wms.newPickingMission.title"}/>}
                            subtitle={<FormattedMessage id={"wms.newPickingMission.subtitle"}/>}
                        />
                    </Grid>

                    <CreatePickingMissionForm/>
                </Grid>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default CreatePickingMissionMobileContainer;